import React, { createContext, useContext, useState, useEffect } from "react";

const RequisitionContext = createContext();

export const useRequisition = () => useContext(RequisitionContext);

export const RequisitionProvider = ({ children }) => {
  const [requisitions, setRequisitions] = useState(() => {
    try {
      const saved = localStorage.getItem("requisitions");
      return saved ? JSON.parse(saved) : [];
    } catch {
      return [];
    }
  });

  useEffect(() => {
    localStorage.setItem("requisitions", JSON.stringify(requisitions));
  }, [requisitions]);

  // 🟢 Create New Request
  const addRequisition = (data) => {
    const newReq = {
      id: `MR-${String(requisitions.length + 1).padStart(4, '0')}`, // Generates MR-0001
      createdAt: new Date().toISOString(),
      status: "Draft", // Draft -> Confirmed -> Approved -> Received
      ...data,
    };
    setRequisitions((prev) => [newReq, ...prev]);
  };

  // 🟢 Update Status (e.g., Approve)
  const updateRequisitionStatus = (id, newStatus) => {
    setRequisitions(prev => prev.map(req => 
      req.id === id ? { ...req, status: newStatus } : req
    ));
  };

  // 🟢 Get Single Request
  const getRequisition = (id) => requisitions.find(r => r.id === id);

  return (
    <RequisitionContext.Provider value={{ requisitions, addRequisition, updateRequisitionStatus, getRequisition }}>
      {children}
    </RequisitionContext.Provider>
  );
};